export const getMaximumStays = ({
  maximumStays = [],
  selectedRatePlanId,
  value,
}) => {
  let results = [];
  // if maximumStays is not a non-empty array, assign a new array with the item
  if (!Array.isArray(maximumStays) || maximumStays.length === 0) {
    results = [{ ratePlanId: selectedRatePlanId, maxStay: value }];
  } else {
    // find if the rate plan already exists
    const index = maximumStays.findIndex(
      (item) => item.ratePlanId === selectedRatePlanId
    );

    // if not found, append the new item by assigning to maximumStays
    if (index === -1) {
      results = [
        ...maximumStays,
        { ratePlanId: selectedRatePlanId, maxStay: value },
      ];
    } else {
      results = [...maximumStays];
    }
    // otherwise update the matching item and keep others by assigning the mapped array
    results = results.map((item) =>
      item.ratePlanId === selectedRatePlanId
        ? { ...item, maxStay: value }
        : item
    );
  }

  return results;
};
